export default __webpack_public_path__ + "static/media/Resume.6a4cd589.pdf";